import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import NotificationsForm from '../Components/NotificationsForm';

import 'react-table/react-table.css';

/*
Component
*/
const MyAlertsView = ({ orgId, currentUser = {}, users, ready, userId }) => {
  const [viewingUser, setViewingUser] = useState({})
  const [isSelf, setIsSelf] = useState(true)

  useEffect(() => {
    if(userId === currentUser.id){
      setIsSelf(true)
      setViewingUser(currentUser)
    }
    else {
      setIsSelf(false)
      setViewingUser(users.find(u=>u.id===userId))
    }
  }, [userId, users]) /* eslint-disable-line */

  return(
    <div className='my-alerts-view'>
      <h1>Notification Settings</h1>
      <br />

      {ready && (<NotificationsForm user={viewingUser} orgId={orgId} editingSelf={isSelf} />)}
    </div>
  )
};

// PropTypes and Redux

MyAlertsView.propTypes = {
  user: PropTypes.shape({
    config_alerts: PropTypes.shape({}).isRequired,
    email: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }),
  orgId: PropTypes.string,
};

MyAlertsView.defaultProps = {
  users: [],
  user: {
    config_alerts: {},
    email: '',
    id: '',
  },
  orgId: '',
};

const mapStateToProps = (state) => {
  const allUserData = state.session.settings.user;
  const { orgId } = state.location.payload;

  return ({
    userId: state.location.payload.id1 ? state.location.payload.id1 : state.session.settings.user.id,
    currentUser: allUserData,
    orgId,
  });
};

export default connect(
  mapStateToProps,
  null
)(MyAlertsView);
